import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import clx from 'classnames'
import { FetchDataUtil } from '@vzmi/component_ec_nodejs_util'
import {
  fetchSeListingPageViews,
  fetchSeSaleStatsByDate
} from '../../../../actions'
import safeAwait from '../../../../../lib/safeAwait'
import PageViewsDaily from '../../../Dashboard/OperatingDashboard/PageViewsAnalysis/PageViewsDaily/PageViewsDaily'
import { getParamsListByMonth } from '../../../Dashboard/OperatingDashboard/Shared'
import { GA_CLICK_ACTION } from '../../../Dashboard/OperatingDashboard/PageViewsAnalysis/PageViewsAnalysis.ga'
import { LISTING_TYPE } from '../../../Dashboard/OperatingDashboard/constants/listing'
import { CARRIER } from '../../../Dashboard/OperatingDashboard/constants/carrier'
import { SELLER_DASHBOARD_ONLINE_DATE } from '../constants'

const PAGE_VIEWS_API_LIMIT = 120

const GA_LABEL_MAP = {
  [GA_CLICK_ACTION.DAILY_COMPARISON_RANGE]: 's_pv_day_compare',
  [GA_CLICK_ACTION.DAILY_EXPORT_EXCEL]: 's_pv_day_downloadfile'
}

const LISTING_GA_LABEL_MAP = {
  [LISTING_TYPE.ALL]: 's_pv_day_allgd',
  [LISTING_TYPE.ORDER]: 's_pv_day_specgd'
}

const CARRIER_GA_LABEL_MAP = {
  [CARRIER.ALL]: 's_pv_day_deviceall',
  [CARRIER.APP]: 's_pv_day_app',
  [CARRIER.MOBILE_WEB]: 's_pv_day_mobileweb',
  [CARRIER.DESKTOP_WEB]: 's_pv_day_desktopweb'
}

const getGaLabel = (action = {}) => {
  const { type, payload } = action

  if (type === GA_CLICK_ACTION.DAILY_LISTING_OPTION) {
    return _.get(LISTING_GA_LABEL_MAP, payload)
  }

  if (type === GA_CLICK_ACTION.DAILY_CARRIERS) {
    return _.get(CARRIER_GA_LABEL_MAP, payload)
  }

  return _.get(GA_LABEL_MAP, type)
}

class PageViewsAnalysis extends Component {
  fetchMonthlyListingPageViews = async (params) => {
    const [error, listingPageViews] = await safeAwait(
      FetchDataUtil.fetchAllPages(params => {
        return this.props.actions.fetchSeListingPageViews(params)
          .then(res => {
            if (res.error) {
              throw res
            }
            return res
          })
      }, {
        payload: params,
        selector: res => _.get(res, 'pageViews', [])
      })
    )
    if (error) {
      return Promise.reject(error)
    }

    return listingPageViews
  }

  fetchAllListingPageViews = async (params) => {
    const paramsWithLimit = {
      limit: PAGE_VIEWS_API_LIMIT,
      ...params
    }
    // API 限制日期區間最長一個月，因此跨月需要分開打
    const paramsList = getParamsListByMonth(paramsWithLimit)
    const [error, allListingPageViewsResp] = await safeAwait(
      Promise.all(
        // 查詢單一個月全部 pageView
        paramsList.map(perMonthParams => this.fetchMonthlyListingPageViews({
          ...paramsWithLimit,
          ...perMonthParams
        }))
      )
    )
    if (error) {
      return Promise.reject(error)
    }

    // 將每個月的 pageView 加總
    const allListingPageViews = _.reduce(allListingPageViewsResp, (sumPageViews, resp) => {
      sumPageViews = sumPageViews.concat(resp.data)
      return sumPageViews
    }, [])
    const pagination = _.flow(
      _.head,
      firstResp => _.get(firstResp, 'pagination')
    )(allListingPageViewsResp)
    return { data: allListingPageViews, pagination }
  }

  sendPageviewByAction = (action) => {
    const { onGaClick } = this.props
    const gaLabel = getGaLabel(action)

    if (gaLabel && onGaClick) {
      onGaClick(gaLabel)
    }
  }

  render () {
    const { className, actions: { fetchSeSaleStatsByDate } } = this.props
    const clz = clx({
      [className]: !!className
    })
    return (
      <div
        className={clz}
        data-role='page-views-analysis'
      >
        <PageViewsDaily
          fetchAllListingPageViews={this.fetchAllListingPageViews}
          fetchSaleStatsByDate={fetchSeSaleStatsByDate}
          sendPageviewByAction={this.sendPageviewByAction}
          isSeller
          onlineDate={SELLER_DASHBOARD_ONLINE_DATE}
        />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = {
    fetchSeListingPageViews,
    fetchSeSaleStatsByDate
  }
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(
  null,
  mapDispatchToProps
)(PageViewsAnalysis)
